import { getSessionManagementServiceInstance } from '~src/sessionManagement/SessionManagementService';

import { SiteRoles } from '../users/serverApi/types/ISiteRole';

/** Value used when no admin profile is selected (shared by Add Local User and Set Site Role). */
export const ADMIN_PROFILE_NONE_VALUE = 'none';

/**
 * Site roles for which the user can choose an admin profile.
 * Admin roles (Site Administrator, Server Administrator) have full capabilities and do not use
 * admin profiles — the dropdown is disabled and effectively None for those roles.
 */
export const SITE_ROLES_ALLOWING_ADMIN_PROFILE: string[] = [
  SiteRoles.Explorer,
  SiteRoles.ExplorerCanPublish,
  SiteRoles.Creator,
];

/**
 * True when the admin profile dropdown is available for the given site role.
 * Returns false when isAdminProfilesEnabledOnServer is off.
 */
export function isAdminProfileChoiceEnabled(siteRole: string): boolean {
  if (!getSessionManagementServiceInstance().isAdminProfilesEnabled()) {
    return false;
  }
  return SITE_ROLES_ALLOWING_ADMIN_PROFILE.indexOf(siteRole) >= 0;
}
